import {
  VESSELS_SET_SEARCH_PARAMS,
  VESSELS_FETCH_DATA,
  VESSELS_FETCH_ERROR,
  VESSELS_ENABLE_LOADING,
  VESSELS_DISABLE_LOADING,
  VESSELS_RESET_FILTERS,
  VESSELS_SET_FILTERS,
  VESSELS_FILTERED_DATA,
  VESSELS_SET_SORT_BY,
  VESSELS_SET_LANDING_PAGE,
  } from 'src/actions/constants';

const defaultState = {
  isLoading: false,
  searchParams: {},
  selectedFilters: {},
  dataWithoutFilters: [],
  sortByFilters: {
    sortBy: 'transitDays',
    sortByOrder: 'ASC',
  },
  isLandingPage: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {

    case VESSELS_SET_LANDING_PAGE: {
      return {
        ...state,
        isLandingPage: true,
      };
    }

    case VESSELS_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
        isLandingPage: false,
      };
    }

    case VESSELS_SET_SEARCH_PARAMS : {
      return {
        ...state,
        searchParams:{
          ...action.data,
        },
      };
    }

    case VESSELS_FETCH_DATA : {
      return {
        ...state,
        errorMessage: undefined,
        searchResults: action.data?.searchResults,
        dataWithoutFilters: action.data?.searchResults,
        transitDaysRange: action.data?.transitDaysRange,
        vesselTransshipment: action.data?.vesselTransshipment,
        allPortsMap: action.data?.allPortsMap,
        allCarriersMap: action.data?.allCarriersMap,
      };
    }

    case VESSELS_FILTERED_DATA : {
      return {
        ...state,
        searchResults: action.data,
      };
    }

    case VESSELS_SET_SORT_BY : {
      return {
        ...state,
        sortByFilters: {
          ...state.sortByFilters,
          ...action.data.filter,
        },
        searchResults: action.data.searchResults,
      };
    }

    case VESSELS_FETCH_ERROR : {
      return {
        ...state,
        errorMessage: action.data,
        searchResults: [],
      };
    }

    case VESSELS_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case VESSELS_RESET_FILTERS: {
      return {
        ...state,
        selectedFilters: defaultState.selectedFilters,
        searchResults: [
          ...state.dataWithoutFilters,
        ],
      };
    }

    case VESSELS_SET_FILTERS : {
      return {
        ...state,
        selectedFilters :{
          ...state.selectedFilters,
          ...action.data,
        },
      };
    }

    default: return state;

  }
};
